import {ClaimManagerBackend} from '../../environments/application-configurations';
import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {AuthService} from '../../authentication/auth-service';
import {ResidenceAutocompletion} from '../entity/residence-autocompletion';


@Injectable({
  providedIn: 'root'
})
export class ResidenceAutocompletionService {
  private readonly claimManagerBackend: ClaimManagerBackend = environment.claimManagerBackend

  constructor(private readonly authService: AuthService) {
  }

  async getPolicyFor(policyNumber: string | undefined | null): Promise<ResidenceAutocompletion | undefined> {
    if (policyNumber == null || policyNumber.length < 1) {
      console.warn(`No policy number provided: ${policyNumber}`);
      return Promise.resolve(undefined);
    }

    const queryParams = new URLSearchParams({policy_number: policyNumber});
    const url = `${this.claimManagerBackend.baseUrl}${this.claimManagerBackend.getMetadataLookupByPolicyNumberPath}?${queryParams.toString()}`
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${this.authService.getIdToken()}`);

    try {
      return await fetch(url, {method: 'GET', headers: headers})
        .then(r => {
          if (r.status == 204) {
            return Promise.resolve(undefined);
          } else if (r.status == 200) {
            return r.json() as Promise<ResidenceAutocompletion>;
          } else {
            return Promise.reject(r.statusText)
          }
        });
    } catch (e) {
      console.error(`Error fetching policy metadata for policy number "${policyNumber}"`, e);
      return undefined;
    }
  }
}
